// Map file to DocumentTypeId. Ids must match Reference__DocumentType
// (PDF=10, WEBP=11, PNG=12, JPG=13, JPEG=14, CSV=15, XLSX=16, XLS=17).
export function getDocumentTypeId(file: File): number {
  const name = file.name.toLowerCase();
  const t = file.type.toLowerCase();

  if (t === "application/pdf" || name.endsWith(".pdf")) return 10; // PDF
  if (t === "image/png" || name.endsWith(".png")) return 12; // PNG
  if (t === "image/webp" || name.endsWith(".webp")) return 11; // WEBP
  if (
    t === "image/jpeg" ||
    t === "image/jpg" ||
    name.endsWith(".jpg") ||
    name.endsWith(".jpeg")
  )
    return 13; // JPG
  if (t === "text/csv" || name.endsWith(".csv")) return 15; // CSV
  if (
    t === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    name.endsWith(".xlsx")
  )
    return 16; // XLSX
  if (t === "application/vnd.ms-excel" || name.endsWith(".xls")) return 17; // XLS
  return 10; // default to PDF for POC; change to 1 (Other) if your backend allows it
}

// Fingerprint used to skip exact re-adds while keeping same-named bills from
// different months. lastModified is the file's own timestamp (ms), which
// varies per download, so it distinguishes otherwise-identical filenames.
export function fileKey(file: File): string {
  return `${file.name}:${file.size}:${file.lastModified}`;
}

export const BILL_UPLOAD_ACCEPT =
  ".pdf,.csv,.xlsx,.xls,application/pdf,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel";
